import moment from "moment";
import {useEffect, useRef, useState} from "react";
import {useParams, useSearchParams} from "react-router-dom";
import AGButton from "../../../components/Button";
import {ThumbnailItemProps} from "./thumbnailItem.props";
import {TagOptionService, TagSponsorService, ThumbNailService} from "./thumbnailItem.styled";
import {RolesVendor} from "../../../components/RolesHandle";
import Tooltip from "../../../components/Tooltip";
import {Tooltip as ReactTooltip} from "react-tooltip";
import {renderToStaticMarkup} from "react-dom/server";
const ThumbnailProductItem: React.FC<ThumbnailItemProps> = ({
  data,
  buttonTextClassName,
  onchangeSelectedService,
  width,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const headerRef = useRef<HTMLDivElement | null>(null);
  const [clampClass, setClampClass] = useState<string>("line-clamp-2");
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const {id: firmId} = useParams();
  const ramdomTooltipID = Math.random().toString();
  const isMobileScreenPage = screenWidth < 769;

  useEffect(() => {
    if (headerRef.current) {
      const headerHeight = headerRef.current.offsetHeight;
      setClampClass(headerHeight > 42 ? "line-clamp-1" : "line-clamp-2");
    }
  }, [data]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleStatusMessage = (statusId: any) => {
    switch (statusId) {
      case 1:
        return "Pending Approval";
      case 2:
        return "Approved";
      case 3:
        return "Pending Modification";
      default:
        return undefined;
    }
  };

  return (
    <ThumbNailService style={{width: screenWidth > 768 ? width : ""}}>
      <div className={`service-backgound relative ${!data?.mainServiceLogo ? `bg-black` : ``}`}>
        {data ? (
          // eslint-disable-next-line jsx-a11y/alt-text
          <img
            className="h-full object-fill w-full  rounded-t-[10px]"
            src={data?.mainServiceLogo ? data?.mainServiceLogo : ""}
          />
        ) : null}
        {data?.sponsorProfile && moment(data?.sponsorStartDate).isSameOrBefore(moment(), "day") ? (
          <TagSponsorService>SPONSORED</TagSponsorService>
        ) : null}
      </div>
      <div className="thumbnail-item">
        <div
          className="thumbnail-header"
          ref={headerRef}
        >
          <h3>
            {data?.mainServiceName}{" "}
            {data?.isDraff ? (
              <>
                <TagOptionService
                  data-tooltip-id={ramdomTooltipID}
                  data-tooltip-html={renderToStaticMarkup("Draft")}
                  className={`${"px-[10px] py-[3px] hover:opacity-70"}`}
                >
                  Draft
                </TagOptionService>
                {/* <ReactTooltip
                  clickable={true}
                  className="tooltipStyleCus"
                  id={ramdomTooltipID}
                /> */}
              </>
            ) : null}
            <RolesVendor
              isDetail={false}
              fkOrgId={Number(firmId)}
              roles={["Admin"]}
            >
              {data && data.fkStatusId ? (
                <div className="lable-container">
                  <TagOptionService
                    data-tooltip-id={ramdomTooltipID}
                    data-tooltip-html={renderToStaticMarkup(handleStatusMessage(data.fkStatusId))}
                    className={`hover:opacity-70 ${
                      isMobileScreenPage ? "px-[10px] py-[3px]" : "inline-block px-[10px] py-[1px]"
                    }`}
                  >
                    {handleStatusMessage(data.fkStatusId)}
                  </TagOptionService>
                  {/* <ReactTooltip
                    clickable={true}
                    className="tooltipStyleCus"
                    id={ramdomTooltipID}
                  /> */}
                </div>
              ) : null}
            </RolesVendor>
          </h3>
        </div>

        <div
          className="thumbnail-body"
          style={{display: "flex", flexWrap: "wrap"}}
        >
          <p
            style={{
              wordWrap: "break-word",
              wordBreak: "break-word",
              whiteSpace: "pre-wrap",
              flex: "1 1 auto",
              minWidth: 0,
            }}
            className={clampClass}
          >
            {data!.detailedDescription}
          </p>
        </div>
      </div>
      <div className="thumbnail-bottom">
        <AGButton
          className={`flex ${buttonTextClassName}`}
          type={"Primary"}
          onClick={(e) => {
            const currentParams = Object.fromEntries(searchParams.entries());
            if (e) {
              setSearchParams({
                ...currentParams,
                serviceId: data!.comOfferingId!.toString(),
              });
              onchangeSelectedService(data!.comOfferingId!);
            }
          }}
        >
          View
        </AGButton>
      </div>
    </ThumbNailService>
  );
};

export default ThumbnailProductItem;
